/* Country/currency eligibility is rendered by Liquid; amounts below are EUR cents. */
if (!customElements.get('ct-free-shipping-bar')) {
  customElements.define('ct-free-shipping-bar', class extends HTMLElement {
    connectedCallback() {
      this.onCartChange = (event) => {
        const cart = event.detail?.cart;
        if (!cart || !Number.isFinite(Number(cart.total_price))) return;
        this.hidden = cart.requires_shipping === false || cart.currency && cart.currency !== 'EUR';
        this.update(Number(cart.total_price));
      };
      document.addEventListener('cart:change', this.onCartChange);
      this.update(Number(this.dataset.total));
    }
    disconnectedCallback() { document.removeEventListener('cart:change', this.onCartChange); }
    update(total) {
      const threshold = Number(this.dataset.threshold);
      if (!(threshold > 0) || !Number.isFinite(total)) return;
      const message = this.querySelector('[data-ct-shipping-message]');
      const progress = this.querySelector('progress');
      const remaining = Math.max(0, threshold - total);
      let formatter;
      try { formatter = new Intl.NumberFormat(this.dataset.locale || 'de-DE', {style: 'currency', currency: 'EUR'}); }
      catch (_) { formatter = new Intl.NumberFormat('de-DE', {style: 'currency', currency: 'EUR'}); }
      if (message) message.textContent = remaining ? this.dataset.unreached.replace('__AMOUNT__', formatter.format(remaining / 100)) : this.dataset.reached;
      if (progress) progress.value = Math.min(threshold, Math.max(0, total));
    }
  });
}
